import React from 'react';
import styles from "page/css/Commentator.module.css";
import userImage from "asset/images/userImage.png";
import Button from "../inputs/Button";
import { Chip, FormControl, Switch, TextField } from "@mui/material";

const CommentatorForm = ({ id, imageUrl, onChangeImageFileHandler, onChangeInput, onChangeSwitch, name, nameEng, invalid, button, onSaveCommentator, className }) => {
    return (
        <form className={className} encType={"multipart/form-data"}>
            <input type={"hidden"} value={id}/>
            <div className={`imgContainer ${styles.imgContainer}`}>
                <img src={imageUrl ? imageUrl : userImage} alt={"preview"} />
                <input id="file" type={"file"} multiple="multiple" name={"imageUrl"} accept={"image/*"} onChange={onChangeImageFileHandler} style={{ display: "none" }} />
                <label className={"labelBtn commentator"} htmlFor={"file"}>{name === null ? "이미지 등록" : "이미지 변경"}</label>
            </div>
            <div className={`txtContainer ${styles.txtContainer}`}>
                <article>
                    <TextField className={`textInput ${styles.textInput}`} defaultValue={name} onChange={onChangeInput} label={name === null && "이름"} name={"name"} variant="standard"  />
                    <TextField className={`textInput ${styles.textInput}`} defaultValue={nameEng} onChange={onChangeInput} label={name === null && "영문 이름"} name={"nameEng"} variant="standard" />
                </article>
                <article>
                    <FormControl sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Chip label="활성화 여부" sx={{ marginBottom: "0.7rem"}} />
                        <div>
                            <span style={{ fontSize: "14px" }}>OFF</span>
                            <Switch
                                name={"invalid"}
                                onChange={onChangeSwitch}
                                sx={{ margin: "0" }}
                                defaultChecked={invalid === false || invalid === "false"}
                            />
                            <span style={{ fontSize: "14px" }}>ON</span>
                        </div>
                    </FormControl>
                </article>
            </div>
            {button && <Button onClick={onSaveCommentator} style={{ marginTop: "auto", marginLeft: "auto", background: "#5a54a1" }}>저장</Button>}
        </form>
    );
};

export default CommentatorForm;